import {
  MEGA_MENU,
  GLOBAL_NAV,
  TOGGLE_SEARCH,
  SET_PROFILE_DATA,
  SET_PROFILE_LOADING,
  SET_RELOGIN,
  SET_MINIAPP,
  SET_BACKENABLED,
  TOGGLE_FILTERS,
  SET_CHECKOUT_LOGIN,
} from "../actionTypes/index";

const initialState = {
  megaMenu: [],
  globalNav: {},
  profileData: null,
  isUserLoggedIn: false,
  isProfileLoading: null,
  isReLogin: false,
  isMiniApp: false,
  isBackEnabled: false,
  isCheckoutLogin: false,
  customerData: null,
  oauthTokenDetails: null,
  subscriptions: [],
  hideNavItems: false,
  isMobileFilter: false
};

const navReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MEGA_MENU:
      return {
        ...state,
        megaMenu: payload,
      };

    case GLOBAL_NAV:
      return {
        ...state,
        globalNav: payload,
      };

    case SET_PROFILE_DATA:
      return {
        ...state,
        profileData: payload.profile,
        isUserLoggedIn: payload.user,
        customerData: payload.customer,
        oauthTokenDetails: payload.oauthTokenDetails,
        subscriptions: payload.subscriptions,
        isProfileLoading: false,
      };

    case TOGGLE_SEARCH:
      return {
        ...state,
        hideNavItems: payload ? true : false,
      };

    case TOGGLE_FILTERS:
      return {
        ...state,
        isMobileFilter: payload ? true : false,
      };

    case SET_PROFILE_LOADING:
      return {
        ...state,
        isProfileLoading: !!payload,
      };

    case SET_RELOGIN:
      return {
        ...state,
        isReLogin: payload ? true : false,
      };
    case SET_CHECKOUT_LOGIN:
      return {
          ...state,
          isCheckoutLogin: payload ? true : false,
      };
    case SET_MINIAPP:
      return {
        ...state,
        isMiniApp: payload ? true : false,
      };
    case SET_BACKENABLED:
      return {
        ...state,
        isBackEnabled: payload ? true : false,
      };
    default:
      return state;
  }
};

export default navReducer;
